import * as React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { Helmet } from "react-helmet";
import shareImage from "../../static/images/share-card.png";
import { siteMetadata } from "../../gatsby-config";

const Layout = ({ props, location, children }) => {
  return (
    <>
      <Helmet>
        <html lang="en"></html>
        {/* <!-- Primary Meta Tags --> */}
        <meta name="title" content={siteMetadata.title}></meta>
        <meta name="description" content={siteMetadata.description}></meta>
        <link
          rel="canonical"
          href={siteMetadata.siteUrl + (location ? location.pathname : "")}
        ></link>
        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:url"
          content={siteMetadata.siteUrl + (location ? location.pathname : "")}
        ></meta>
        <meta name="title" property="og:title" content={siteMetadata.title} />
        <meta
          name="description"
          property="og:description"
          content={siteMetadata.description}
        ></meta>
        <meta
          property="og:image"
          content={siteMetadata.siteUrl + shareImage}
        ></meta>
        {/* <!-- Twitter --> */}
        <meta property="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:url"
          content={siteMetadata.siteUrl + (location ? location.pathname : "")}
        ></meta>
        <meta property="twitter:title" content={siteMetadata.title}></meta>
        <meta
          property="twitter:author"
          content={siteMetadata.social.twitterUsername}
        ></meta>
        <meta
          property="twitter:description"
          content={siteMetadata.description}
        ></meta>
        <meta
          property="twitter:image"
          content={siteMetadata.siteUrl + shareImage}
        ></meta>
        <script
          id="hs-script-loader"
          async
          defer
          src="//js-na1.hs-scripts.com/7032750.js"
        ></script>
        <meta
          name="twitter:image"
          property="og:image"
          content={siteMetadata.siteUrl + shareImage}
        ></meta>
        {/* <link property="image" href={siteMetadata.siteUrl + shareImage} /> */}
      </Helmet>
      <Navigation />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
